module.exports = __webpack_public_path__ + "img/star_g.ade408be.svg";